import { BaseCommand } from './baseCommand';
import Element, { ElementType, SpecyficType } from '../element';

// WORK IN PROGRESS
export class RemoveSeparatingWallCommand extends BaseCommand {

    constructor(
        private drawer: Element,
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public execute() {
        const offsetY = this.drawer.position.y === 1 ? 1 : -1;
        const neighbourDrawer: Element = this.scenePreview.elements
            .filter((x: Element) => x.specyficType === SpecyficType.DRAWER &&
                x.position.x === this.drawer.position.x &&
                x.position.y === this.drawer.position.y + offsetY)[0];
        if (!neighbourDrawer) { return; }
        const separatingWall = this.scenePreview.elements.
            find((x: Element) => x.type === ElementType.WALL &&
                x.position.x === neighbourDrawer.position.x &&
                x.position.y === neighbourDrawer.position.y - (offsetY / 2));
        if (!separatingWall) { return; }
        this.elements.push(separatingWall);
        separatingWall.isVisible = false;
        this.scenePreview.elements.splice(
            this.scenePreview.elements.indexOf(separatingWall), 1,
        );
        const shadowMeshes = neighbourDrawer.meshes.filter((x) => x.name.includes('shadow'));
        shadowMeshes.forEach((x) => x.visibility = 0);
    }

    public revert() {
        this.elements.forEach((element) => {
            element.isVisible = true;
            this.scenePreview.elements.push(element);
        });
    }
}
